import React from 'react';
import { connect } from 'react-redux';

// Actions
import { loadOrganizations } from '../../services/organizations/actions';

interface Props {
    loadOrganizations: Function;
}

export class OrganizationsRequest extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.loadOrganizations();
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    { loadOrganizations }
)(OrganizationsRequest);
